import { createActions } from 'redux-actions';

import { SimulationFilter } from '../../reducers/SimulationReducer/FiltersReducer/FiltersReducer.types';
import { Dispatch } from 'redux';
import { StateType } from '../../reducers';
import { SIMULATE } from '../../shared/constants';
import type { History } from 'history';
import { fixPathAfterFiltersChange } from './FixPathAfterFiltersChangeAction';
import { TutorialActions } from '../../reducers/TutorialReducer/TutorialReducer';
import { getUserPermissionSet } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { patchConsultantTutorialActive } from '../../shared/api/api';

export const { toggleSimulationFilter, setDefaultFilters, toggleSimulationFilterMobile, updateFiltersForSingleFilter, resetFilters } =
  createActions(
    {
      TOGGLE_SIMULATION_FILTER: (filter: SimulationFilter, tabIndex: number) => ({ filter, tabIndex }),
      SET_DEFAULT_FILTERS: (filter: Object, tabIndex: number) => ({ filter, tabIndex }),
      TOGGLE_SIMULATION_FILTER_MOBILE: (tabIndex: number, codeType: string) => ({ tabIndex, codeType }),
    },
    'UPDATE_FILTERS_FOR_SINGLE_FILTER',
    'RESET_FILTERS'
  );

export const toggleSimulationFilterThunk =
  (filter: SimulationFilter, tabIndex: number, history: History<unknown>) => (dispatch: Dispatch<any>, getState: () => StateType) => {
    const state = getState();

    //enable tutorial mode whenever the tutorial tab is switched on
    if (filter === 'tutorial') {
      const currentFilterState = state.getIn(['simulation', 'filters', tabIndex, filter]) as boolean | undefined;
      if (currentFilterState === false) {
        if (getUserPermissionSet(state).has('CONSULTANT')) {
          patchConsultantTutorialActive(true);
        } else {
          dispatch(TutorialActions.enableTutorialMode());
        }
      }
    }

    dispatch(toggleSimulationFilter(filter, tabIndex));

    dispatch(fixPathAfterFiltersChange(history));
  };

export const toggleSimulationFilterMobileThunk =
  (tabIndex: number, codeType: string, historyReplace: (path: string) => void) => (dispatch: Dispatch<any>, getState: () => StateType) => {
    dispatch(toggleSimulationFilterMobile(tabIndex, codeType));
    historyReplace(SIMULATE);
  };
export const updateFiltersForSingleFilterThunk =
  (historyReplace: (path: string) => void) => (dispatch: Dispatch<any>, getState: () => StateType) => {
    dispatch(updateFiltersForSingleFilter());
    historyReplace(SIMULATE);
  };
